export const SAVE = 'TripInterruptionTugo.SAVE';
export const VALUE_CHANGED = 'TripInterruptionTugo.VALUE_CHANGED';
export const LOAD = 'TripInterruptionTugo.VALUE_LOAD';
export const NEXT = 'TripInterruptionTugo.NEXT';
export const RESET = 'TripInterruptionTugo.RESET';
export const RESET_FORM_STATE = 'TripInterruptionTugo.RESET_FORM_STATE';

export const CLAIMING_FOR = {
  PASSPORT_CREDIT_CARD: 'claimForPassportCreditCard',
  THEFT_OF_CASH: 'claimForTheftOfCash',
  LUGGAGE_AND_PERSONAL_EFFECTS: 'claimForLuggageAndPersonalEffect',
};



// WEBPACK FOOTER //
// ./app/containers/FastCover/Tugo.TripInterruption/constants.js